import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import Tasks from './tasks';
import configureStore from './store/configure';
import { VIEW_TASKS_PROJECTS } from 'helpers/tasks/constants';

export class TasksIndex extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callListsAccess: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired
  };

  store = configureStore({
    paths: this.props.paths,
    query: {
      assigneeId: this.props.currentUser.id,
      creatorId: null,
      endDate: null,
      includeUntagged: false,
      searchText: '',
      startDate: null,
      taskType: null,
      tagIds: []
    },
    search: {
      hasNextPage: false,
      lastPageLoaded: 0,
      tags: [],
      tasks: [],
      isFetching: false
    },
    static: {
      availableDatabases: this.props.availableDatabases,
      callListsAccess: this.props.callListsAccess,
      currentUser: this.props.currentUser,
      databaseMembers: this.props.databaseMembers
    },
    ui: {
      activeView: VIEW_TASKS_PROJECTS
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <Tasks />
      </Provider>
    );
  }
}

export default TasksIndex;
